import { useEffect, useState } from "react";
import AnimatedNumber from "react-animated-numbers";

export default function Etheroll({ mustStartSpinning, prizeNumber, onRoll }) {
  const [isSpinning, setIsSpinning] = useState(false);
  useEffect(() => {
    if (mustStartSpinning) {
      setIsSpinning(true);
    }
  }, [mustStartSpinning]);

  useEffect(() => {
    if (isSpinning) {
      setTimeout(() => {
        setIsSpinning(false);
        onRoll();
      }, 2000);
    }
  }, [isSpinning, onRoll]);

  return (
    <div style={{ fontSize: "2rem" }}>
      <AnimatedNumber
        animateToNumber={prizeNumber}
        configs={[
          { mass: 5, tension: 220, friction: 100 },
        ]}
      />
    </div>
  );
}
